export const TEST_ID = {
  progressIndicator: 'progressIndicator',
};
